import styled from 'styled-components';
import { device } from './Theme';

export const StyledContact = styled.section`
  padding: 6rem 1.8rem;

  @media ${device.tablet} {
    padding: 4.2rem 1.8rem;
  }

  @media ${device.mobile} {
    padding: 3.8rem 1.2rem;
  }
`;

export const Container = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  max-width: 1000px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;

  @media ${device.tablet} {
    grid-template-columns: 1fr;
    gap: 4rem;
  }

  @media ${device.mobile} {
    gap: 3rem;
  }
`;

export const Col = styled.div``;

export const Form = styled.form`
  max-width: 30rem;
`;

export const FormControl = styled.div`
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;

  label {
    font-size: 0.95rem;
    margin-bottom: 0.2rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.heading};
  }

  input,
  textarea {
    padding: 0.55rem 0.8rem 0.6rem;
    max-width: 100%;
    min-width: 100%;
    font-size: 1rem;
    border: 1px solid #a1a1a1;
    border-radius: ${({ theme }) => theme.borderRadius};
  }
  textarea {
    resize: vertical;
  }

  input:focus,
  textarea:focus {
    outline-offset: unset;
    outline: 1px solid currentColor;
    border-color: currentColor;
  }

  input.invalid,
  textarea.invalid {
    border: 1px solid hsl(0, 100%, 74%);
    outline: 1px solid hsl(0, 100%, 74%);
  }

  @media ${device.mobile} {
    label {
      font-size: 0.9rem;
    }

    input,
    textarea {
      padding: 0.5rem 0.7rem 0.6rem;
      font-size: 0.95rem;
    }
  }
`;

export const Button = styled.button`
  padding: 0.9em 1em;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.primary};
  font-size: 1rem;
  color: #fff;
  transition: ${({ theme }) => theme.transition};
  display: flex;
  align-items: center;
  gap: 0.45rem;

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.colors.hoverPrimary};
  }

  @media ${device.mobile} {
    font-size: 0.95rem;
  }
`;

export const ColInfo = styled.div`
  /* padding-top: 2rem; */
  padding-right: 2.5rem;
  order: -1;

  h2 {
    margin-bottom: 1rem;
    font-size: 2rem;
  }
  p {
    margin-bottom: 2rem;
    color: #666666;
  }
  small {
    margin-bottom: 0.4rem;
    display: block;
  }

  @media ${device.laptop} {
    padding-left: 1.6rem;
  }
  @media ${device.tablet} {
    padding: 0;
    /* order: -1; */
  }
  @media ${device.mobile} {
    h2 {
      font-size: 1.4rem;
    }
    p {
      font-size: 0.95rem;
    }
  }
`;

export const Info = styled.ul`
  margin-bottom: 2rem;
  li {
    display: flex;
    gap: 1em;
    align-items: center;
    margin-bottom: 0.5rem;

    svg {
      font-size: 1.1rem;
      flex-shrink: 0;
    }
  }

  @media ${device.mobile} {
    li {
      margin-bottom: 0.3rem;

      svg {
        font-size: 1.1rem;
      }
      span {
        font-size: 0.95rem;
      }
    }
  }
`;

export const Social = styled.ul`
  list-style: none;
  display: flex;
  gap: 1rem;

  a {
    border: 1px solid #eaeaea;
    border-radius: 50%;
    height: 2.5rem;
    width: 2.5rem;
    display: grid;
    place-content: center;
    transition: ${({ theme }) => theme.transition};
    &:hover {
      border-color: currentColor;
    }
  }

  svg {
    font-size: 1rem;
  }

  @media ${device.mobile} {
    gap: 0.8rem;
    a {
      height: 2.3rem;
      width: 2.3rem;

      svg {
        font-size: 0.95rem;
      }
    }
  }
`;

export const Error = styled.p`
  color: hsl(0, 100%, 74%);
  font-size: 0.78rem;
  padding-top: 0.5rem;
  line-height: 1;
  font-weight: 600;
`;
